module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av260-866545aaddaf1166d06e9a0ed0a39748.jpg";